import { configureStore } from '@reduxjs/toolkit';
import messageSlice from './messageSlice';
import tabSlice from './tabSlice';
import loadingReducer from './LoadingSlice';
import menuSlice from './menuSlice';
import pageAuthSlice from './pageAuthSlice';

const store = configureStore({
  reducer: {
    infoMessage: messageSlice,
    tabs: tabSlice,
    loading: loadingReducer,
    menu : menuSlice,
    pageAuth : pageAuthSlice
  },
});

export default store;
